import React, { Component } from 'react';

class InputOnClick extends Component
{
	constructor(props) {
		super(props);

		this.state = {
			input: (this.isNullValue(this.props.defaultValue)) ? true : false,
			value: this.props.defaultValue,
			busy: false
		};

		this.initialValue = this.props.defaultValue;
		this.elementRef = React.createRef();
		this.onDoubleClick = this.onDoubleClick.bind(this);
		this.onKeyDown = this.onKeyDown.bind(this);
	}

	isNullValue (value) {
		return (
			value === ""    || 
			value === null  || 
			value === false ||
			value === undefined
		);
	}

	handleClickOutside = (evt) => {
		if (!this.isNullValue(this.state.value) && this.state.input === true) {
			this.setState({ input: false });
		}
	}

	onKeyDown (e) {
		const that = this;
		if (e.key === 'Enter' && (this.initialValue !== e.target.value)) {
			if (this.props.onEnter) {
				const value = e.target.value;
				this.setState({ busy: true });
				this.props.onEnter(value).then(function () {
					that.setState({ input: false, value: value, busy: false });
					this.initiaValue = value;
				})
			}
		} else if (e.key === 'Escape' && this.state.value !== null) {
			this.setState({ input: false });
		}
	}

	onDoubleClick (e) {
		const that = this;
		this.setState({
			input: this.state.input ? false : true
		}, function () {
			that.elementRef.current.focus();
			const val = that.elementRef.current.value;
			that.elementRef.current.value = "";
			that.elementRef.current.value = val;
		});
	}

	render () {
		const that = this;

		let input = [true].map(function () {
			return (
				<input 
					onKeyDown={that.onKeyDown}
					className={that.props.className}
					defaultValue={that.state.value}
					type={that.state.input ? 'text' : 'hidden'}
					ref={that.elementRef}
					key={that.props.key + ".input-on-click"}
				/>
			);
		});

		return (
			<section>
				<div className={this.state.busy ? "control is-loading" : "control"}>
					{input}
				</div>
				<span onDoubleClick={this.onDoubleClick} style={{display: (this.state.input) ? 'none' : 'initial'}}>
					{this.state.value}
				</span>
			</section>
		);
	}
}

export default InputOnClick;


// WEBPACK FOOTER //
// ./src/Components/InputOnClick.js